module.exports = __webpack_public_path__ + "static/media/uno.ea819769.svg";